import yup, {
    cardNameValidator,
    imageValidator,
    integerPositiveValidator,
    stringValidator,
} from '~/utils/validators.yup';

export const schema = (nullable = false) =>
    yup.object({
        name: cardNameValidator(),
        description: stringValidator.max(300).required(),
        image: imageValidator(nullable),
        boonId: integerPositiveValidator,
        alignmentId: integerPositiveValidator,
    });
